import React, {useState} from "react";
import {useForm} from "react-hook-form";
import StoreFields from "./StoreFields";

export default function () {
    const {register, handleSubmit, reset, control} = useForm();
    const [errors, setErrors] = useState({});
    const [data, setData] = useState({});
    const storeFields = <StoreFields {...{register, errors, control, data}} />;

    return {
        setErrors,
        storeFields,
        handleSubmit,
        reset,
        setData,
    }
}